import React from 'react'
import { BackdropProps } from 'src/types/--deprecated/types'

import './backdrop.scss'

const Backdrop: React.FC<BackdropProps> = (props: BackdropProps) =>
  props.show ? <div className="backdrop" onClick={props.clicked}></div> : null

export default Backdrop
